import { PropsWithChildren } from 'react';
import { Flex } from '@chakra-ui/react';

const RatingDescription = ({
  activeValue,
  value,
  children,
  ...props
}: PropsWithChildren<RatingDescriptionProps>): JSX.Element => {
  return (
    <Flex
      direction="column"
      flex={0.33}
      fontWeight={500}
      fontSize="14px"
      lineHeight="16.8px"
      letterSpacing="5%"
      color={activeValue === value ? 'custom.levoBlue' : '#999999'}
      {...props}
    >
      {children}
    </Flex>
  );
};

export default RatingDescription;
